/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LogMessageDto } from '../../models/log-message-dto';

export interface UpdateLogMessage$Params {
  id: string;
      body: LogMessageDto
}

export function updateLogMessage(http: HttpClient, rootUrl: string, params: UpdateLogMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<LogMessageDto>> {
  const rb = new RequestBuilder(rootUrl, updateLogMessage.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LogMessageDto>;
    })
  );
}

updateLogMessage.PATH = '/v1/logmessage/{id}';
